import { createContext } from 'react';

export const AppNavigationContext = createContext({});
